import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import { Methods } from '../../../shared/methods';

declare const $: any;

@Component({
  selector: "app-table-scraps",
  templateUrl: "./table-scraps.component.html",
  styleUrls: ["./table-scraps.component.css"],
})
export class TableScrapsComponent implements OnInit, AfterViewInit {
  @Input() data: any[] = [];
  @Input() bulk: number[] = [];
  public test: Array<number> = [];
  @Input() status: boolean = false;
  @Output() change: EventEmitter<any>;

  @Output() verComentarios: EventEmitter<any>;

  public saving = false;
  public mtds: Methods = new Methods();

  constructor() {
    this.change = new EventEmitter();
    this.verComentarios = new EventEmitter();
    this.test = this.bulk;
  }

  ngOnInit() {
    console.log(this.data);
  }

  checkAll() {
    let item;
    for (item of this.data) {
      if (!this.check(item.id)) {
        return false;
      }
    }
    return true;
  }

  check(id) {
    let i;
    for (i of this.bulk) {
      if (i === id) {
        return true;
      }
    }
    return false;
  }

  selectAll() {
    if (this.checkAll()) {
      this.bulk = [];
    } else {
      this.bulk = [];
      let item;
      for (item of this.data) {
        this.bulk.push(item.id);
      }
    }
    this.change.emit(this.bulk);
  }

  selectItem(id) {
    this.bulk = this.test;

    let i,
      find = false;
    for (i = 0; i < this.bulk.length; i++) {
      if (this.bulk[i] === id) {
        this.bulk.splice(i, 1);
        find = true;
        break;
      }
    }

    if (!find) {
      this.bulk.push(id);
    }
    this.test = this.bulk;
    this.change.emit(this.bulk);
  }

  ngAfterViewInit() {
    $("#selectScraps").DataTable({
      order: [[0, "desc"]],
      dom: "Bflrtip",
      buttons: [
        /*{
            extend: 'copy',
            exportOptions: {
              columns: ':visible'
            }
          },*/ /*
          {
            extend: 'csv',
            exportOptions: {
              columns: ':visible'
            }
          },*/
        {
          extend: "excel",
          text: '<i class="fa fa-file-excel-o"></i>',
          titleAttr: "Excel",
          className: "btn btn-sm btn-outline-success",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "pdf",
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: "PDF",
          className: "btn btn-sm btn-outline-danger",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "print",
          text: '<i class="fa fa-print" aria-hidden="true"></i>',
          titleAttr: "print",
          className: "btn btn-sm btn-outline-primary",
          exportOptions: {
            columns: ":visible",
          },
        },
        {
          extend: "colvis",
          text: '<i class="fa fa-columns" aria-hidden="true"></i>',
          className: "btn btn-sm btn-outline-info",
          titleAttr: "Column visibility",
        },
      ],
      pagingType: "full_numbers",
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, "All"],
      ],
      responsive: true,
      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search records",
      },
    });
  }

  openComments(item) {
    console.log(item);
    this.verComentarios.emit(item);
  }
}
